import React from "react";
import { createTheme } from "@material-ui/core/styles";

import {
  Admin,
  Resource,
  ListGuesser,
  ShowGuesser,
  Show,
  SimpleShowLayout,
  TextField,
  RichTextField,
  EditGuesser,
  Create,
  ReferenceInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectInput,
  TextInput,
  SimpleForm,
  FileInput,
  FileField,
  useRedirect,
  useNotify,
} from "react-admin";
import jsonServerProvider from "ra-data-json-server";
import MusicCreate from "./Music/MusicCreate";
import ArtistCreate from "./Artist/ArtistCreate";
import MusicShow from "./Music/MusicShow";
import ArtistShow from "./Artist/ArtistShow";
import AlbumCreate from "./Album/AlbumCreate";
import { baseUrl } from "../../services/dataProvider";
import GenerCreate from "./Gener/GenerCreate";
const dataProvider = jsonServerProvider(baseUrl);

const theme = createTheme({
  palette: {
    type: "dark", // Switching the dark mode on is a single property value change.
  },
});
let myProvider = {
  ...dataProvider,
  create: (resource, params) => {
    if (resource === "music") {
      console.log(params);
      const {
        name,
        description,
        Artist_ids,
        Album_ids,
        Geners_ids,
        song_poster,
      } = params.data;
      let fd = new FormData();
      fd.append("song_poster", song_poster.rawFile);
      fd.append(
        "meta",
        JSON.stringify({
          name,
          description,
          Artist_ids,
          Album_ids,
          Geners_ids,
        })
      );
      params.data.song.forEach((song) => {
        console.log(song.rawFile);
        fd.append("files[]", song.rawFile);
      });
      return fetch(`${baseUrl}/${resource}`, {
        method: "post",
        body: fd,
        credentials: "include",
      }).then(({ json }) => ({
        data: { json, id: json.id },
      }));
    }
    return dataProvider.create(resource, params);
  },
};

export default function AdminPage({ history }) {
  return (
    <Admin theme={theme} dataProvider={myProvider} history={history}>
      <Resource
        name="music"
        list={ListGuesser}
        show={MusicShow}
        edit={EditGuesser}
        create={MusicCreate}
      />
      <Resource
        name="artists"
        list={ListGuesser}
        show={ArtistShow}
        edit={EditGuesser}
        create={ArtistCreate}
      />
      <Resource name="albums" list={ListGuesser} create={AlbumCreate} />
      <Resource name="geners" list={ListGuesser} create={GenerCreate} />
    </Admin>
  );
}
